import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'bootstrap';
import cx from 'classnames';
import { PasswordResetRequired } from './passwordUpdateRequired';
import { LoginForms } from '../login/Login';
import { PasswordResetForm } from './passwordResetForm';
import loginStyles from '../login/styles/login.scss';
import { PasswordResetSent } from './passwordResetSuccess';
import { getDeviceType } from '../../utils/utils';
const Config = require('Config');

export interface PasswordResetProps {
  currentForm: LoginForms;
  setCurrentForm: (value: LoginForms) => void;
  handleClearState: () => void;
}


export interface TargetPayload {
  target: 'sms' | 'email';
  email: string;
  phone?: string;
};

export const PasswordResetScreens: FC<PasswordResetProps> = ({
  currentForm,
  setCurrentForm,
  handleClearState,
}) => {
  const features = useSelector<RootState, string[]>((state) => state.app.features);
  const cpua4769Web = features.includes('CPUA-4769-WEB');
  const isUniversalLinkEnabled = features.includes('cb07431ef6713159ea018cfe46575df241f90dfc017c7a6b458f7cfb8b8834d0');
  const [sentTarget, setSentTarget] = useState<TargetPayload | undefined>();
  const backToLogin = () => {
    if (getDeviceType() !== 'Desktop') {
      window.location.href = isUniversalLinkEnabled ? Config.backToLoginBranchUrl : 'rtspro://back_to_login';
    } else {
      handleClearState();
      setCurrentForm(LoginForms.VERIFICATION_REQUEST);
    }
  };

  return (
    <div className={cx(loginStyles.container, cpua4769Web && loginStyles.zoomedHeight)}>
      <div className={loginStyles.loginWindow}>
        {currentForm === LoginForms.FORCE_PASSWORD_RESET && (
          <PasswordResetRequired setCurrentForm={setCurrentForm} handleClearState={handleClearState} />
        )}
        {currentForm === LoginForms.PASSWORD_RESET_FORM && (
          <PasswordResetForm
            backToLogin={backToLogin}
            setCurrentForm={setCurrentForm}
            setTarget={setSentTarget}
          />
        )}
        {currentForm === LoginForms.PASSWORD_RESET_SENT && (
          <PasswordResetSent target={sentTarget} backToLogin={backToLogin} />
        )}
      </div>
    </div>
  );
};
